import "./Pagecontent.css";
import {
  InstructionDetail,
  CompanyOverviewQuestions,
  StaticDialogText,
  DynamicDialogSubText,
  DynamicDialogYesButtonText,
  DynamicDialogNoButtonText,
  CompanyOverviewCategory,
  getDynamicDialogText,
} from "../../Data/CompanyOverview";
import {
  filingCategories,
  filingCategoriesTemplates,
  filingExcemptionHeaderText,
  filingExcemptionTileHeaderText,
} from "../../Data/FilingExemptions";

import React, { useState, useEffect } from "react";
import {
  findByIds,
  getVetifiedSelectedCategories,
  isLastSelection,
  resetAllCategoryAndQuestions,
  showDynamicModal,
} from "../../Utils/utils";
import Result from "../Result/Result";

function Pagecontent(props) {
  const [resultsEnabled, setResultsEnabled] = useState(false);

  const [companyQuestion, setCompanyQuestion] = useState(
    CompanyOverviewQuestions
  );

  //#region Company Information

  const [showLearnMore, setShowLearnMore] = useState(false);

  const toggleLearnMore = () => {
    setShowLearnMore(!showLearnMore);
  };

  const companyOverviewHeader = (
    <div>
      <div className="overview-header-instruction-title">
        <span><strong>CTA</strong><em>Comply</em><sup>TM</sup> Corporate Transparency Act Eligibility Wizard</span>
      </div>
      <div className="overview-header-instruction-detail">
        {InstructionDetail}
        <span onClick={toggleLearnMore} className="learn-more">
          Learn More
        </span>
      </div>

      {showLearnMore && (
        <div className="static-dialog learn-more-container">
          <p>
            Effective January 1, 2024, companies that fall under the category of
            “reporting company” as defined by the final reporting rules of the
            Corporate Transparency Act will be required to file a Beneficial
            Ownership Information (BOI) Report. Every reporting company must
            comply with this new rule in order to avoid potential fines or other
            penalties.
          </p>

          <p>
          The Corporate Transparency Act provides 23 possible exemptions across various 
          regulated industries. Our wizard will help you to determine if you are required 
          to file as an eligible reporting company or if you meet the requirements of one 
          or more exemptions and therefore do not need to file. This wizard should not be 
          considered in place of legal advice.
          </p>
        </div>
      )}

      <div className="overview-header-title">
        <span>Company Overview</span>
      </div>
    </div>
  );

  const handleCompanyQuestionClick = (selectedOption, question) => {
    let oldQuestions = [...companyQuestion];
    oldQuestions.find((q) => q.order === question.order).selection =
      selectedOption;

    if (oldQuestions[0].selection === "No") {
      oldQuestions.forEach((q) => {
        if (q.order !== 1) {
          q.selection = null;
        }
      });
    }

    setCompanyQuestion(oldQuestions);
    resetSelectedTiles();
    resetAllCategoryAndQuestions([...filingCategories], new Set());
  };

  const companyOverviewContent = (
    <div className="company-overview-content">
      <div>
        {companyQuestion.map((question, _index, _companyQuestions) => {
          return (
            <div key={`${question.title}-${question.id}`}>
              {_index > 0 && _companyQuestions[0].selection !== "Yes" ? (
                <div></div>
              ) : (
                <div
                  key={question.order}
                  className="company-question-container"
                >
                  <div className="company-question-title-container">
                    <div>
                      <span className="question-label">{question.title}</span>
                      {question.tooltil && (
                        <span title={question.tooltil} className="info-icon">
                          &#9432;
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="question-radio-container">
                    <label className="radio-label-container">
                      <input
                        type="radio"
                        name={`${question.title}-${question.id}`}
                        value="Yes"
                        onChange={() =>
                          handleCompanyQuestionClick("Yes", question)
                        }
                        checked={question.selection === "Yes"}
                      />
                      <span className="radio-label-container-option">Yes</span>
                    </label>
                    <label className="radio-label-container">
                      <input
                        type="radio"
                        name={`${question.title}-${question.id}`}
                        value="No"
                        onChange={() =>
                          handleCompanyQuestionClick("No", question)
                        }
                        checked={question.selection === "No"}
                      />
                      <span className="radio-label-container-option">No</span>
                    </label>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );

  //#endregion

  //#region Static Dialog
  const staticDialog = (
    <>
      {companyQuestion?.[0].selection === "No" && (
        <div className="static-dialog">
          <div className="static-dialog-warning-container">
            <span className="warning-icon">&#9888;</span>
          </div>
          <div className="static-dialog-warning-text-container">
            {StaticDialogText}
          </div>
        </div>
      )}
    </>
  );
  //#endregion

  //#region Dynamic Dialog For Company Overview

  const [showDynamicDialogForCompany, setShowDynamicDialogForCompany] =
    useState(false);

  const handleDynamicDialogButtonClick = (value, category) => {
    if (category.categoryId === 100) {
      if (value === "Yes") {
        setFilingExcemptionEnabled(true);
        if (resultsEnabled) {
          setResultsEnabled(false);
        }
        autoScrollCategoryTiles(`filing-exemptions `);
      } else {
        setResultsEnabled(true);
      }
      return;
    }

    let oldCategories = [...filingExcemptionCategories];
    oldCategories.find(
      (c) => c.categoryId === category.categoryId
    ).modalResponded = value;
    setFilingExcemptionCategories(oldCategories);

    if (value === "No") {
      setResultsEnabled(true);
    }

    if (value === "Yes") {
      scrollToNextCategory(oldCategories, category);
    }
  };

  const dynamicDialog = (category) => {
    return (
      <>
        <div className={`dynamic-dialog dynamic-dialog-${category.categoryId}`}>
          <div className="dynamic-icon">
            <span className="warning-icon">&#9888;</span>
          </div>
          <div className="dynamic-dialog-content">
            <div className="dynamic-dialog-content-primary">
              {getDynamicDialogText(category)}
            </div>
            <div className="dynamic-dialog-content-secondary">
              <br />
              {DynamicDialogSubText}
            </div>
            <div className="dynamic-dialog-content-buttons">
              <div className="dynamic-dialog-buttons-yes">
                <button
                  className="dynamic-dialog-buttons"
                  onClick={() =>
                    handleDynamicDialogButtonClick("Yes", category)
                  }
                >
                  {DynamicDialogYesButtonText}
                </button>
              </div>
              <div className="dynamic-dialog-buttons-no">
                <button
                  className="dynamic-dialog-buttons"
                  onClick={() => handleDynamicDialogButtonClick("No", category)}
                >
                  {DynamicDialogNoButtonText}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  //#endregion

  //#region Filing Excemption
  const [filingExcemptionEnabled, setFilingExcemptionEnabled] = useState(false);

  const [filingExcemptionTiles, setFilingExcemptionTiles] = useState(
    filingCategoriesTemplates
  );

  const [filingExcemptionCategories, setFilingExcemptionCategories] =
    useState(filingCategories);

  const filingExcemptionHeader = (
    <div className="filing-excemption-header-title">
      <span>{filingExcemptionHeaderText}</span>
    </div>
  );

  useEffect(() => {
    const allAnswered = companyQuestion?.every((q) => q.selection !== null);
    const allAnsweredYes = companyQuestion.every((q) => q.selection === "Yes");
    const isFirstAnswerNo = companyQuestion[0].selection === "No";

    props.updateCompanyState(companyQuestion);

    //#region First Question - No case
    if (isFirstAnswerNo) {
      setFilingExcemptionEnabled(false);
    }

    if (allAnswered && !allAnsweredYes) {
      setFilingExcemptionEnabled(true);
      autoScrollCategoryTiles(`filing-exemptions`);
    } else {
      setFilingExcemptionEnabled(false);
    }

    if (allAnsweredYes) {
      setShowDynamicDialogForCompany(true);
      autoScrollCategoryTiles(`dynamic-dialog`);
    } else {
      setShowDynamicDialogForCompany(false);
    }
    //#endregion
  }, [companyQuestion]);

  useEffect(() => {
    const allAnswered = companyQuestion?.every((q) => q.selection !== null);
    const isFirstAnswerNo = companyQuestion[0].selection === "No";

    if (isFirstAnswerNo) {
      setResultsEnabled(true);
    } else {
      if (!allAnswered) {
        setResultsEnabled(false);
      }
    }

    if (allAnswered && resultsEnabled) {
      setResultsEnabled(false);
    }
  }, [companyQuestion]);

  useEffect(() => {
    props.updateResultState(resultsEnabled);

    if (resultsEnabled) {
      clearTimeout(scrollTimeout);
      var scrollTimeout = setTimeout(function () {
        const element = document.getElementsByClassName("result");
        if (element && element.length > 0) {
          element[0].scrollIntoView({ behavior: "smooth" });
          clearTimeout(scrollTimeout);
        }
      }, 100); // 100 milliseconds delay
    }
  }, [resultsEnabled]);

  const autoScrollToNextCategory = (categoryId) => {
    clearTimeout(scrollToNextCategory);
    var scrollToNextCategory = setTimeout(function () {
      const element = document.getElementsByClassName(
        `filing-questions-category-${categoryId}`
      );
      if (element && element.length > 0) {
        element[0].scrollIntoView({ behavior: "smooth" });
        clearTimeout(scrollToNextCategory);
      }
    }, 100); // 100 milliseconds delay
  };

  const autoScrollCategoryTiles = (className) => {
    clearTimeout(scrollToNextCategory);
    var scrollToNextCategory = setTimeout(function () {
      const element = document.getElementsByClassName(`${className}`);
      if (element && element.length > 0) {
        element[0].scrollIntoView({ behavior: "smooth" });
        clearTimeout(scrollToNextCategory);
      }
    }, 100); // 100 milliseconds delay
  };

  const resetSelectedTiles = () => {
    let oldCategories = [...filingExcemptionTiles];
    oldCategories.forEach((c) => (c.selected = false));
    setFilingExcemptionTiles(oldCategories);
  };

  const selectCategory = (category) => {
    let oldCategories = [...filingExcemptionTiles];
    let targetCategory = oldCategories.find(
      (cat) => cat.categoryId === category.categoryId
    );
    targetCategory.selected = targetCategory.selected ? false : true;
    setFilingExcemptionTiles(oldCategories);
  };

  const getTileRow = (catIds) => {
    return (
      <>
        {findByIds(filingExcemptionTiles, "categoryId", catIds).map(
          (category) => {
            return (
              <div
                key={`filing-tile-${category.categoryId}`}
                className={`filing-tile ${
                  category.selected ? `filing-tile-selected` : ``
                }`}
                onClick={() => {
                  selectCategory(category);
                }}
              >
                {category.categoryTitle}
              </div>
            );
          }
        )}
      </>
    );
  };

  const handleNoneApplyButton = () => {
    let defaultCategories = [...filingCategories];
    let tiles = [...filingExcemptionTiles];
    tiles.forEach(t => {
      t.selected = false;
    })
    resetAllCategoryAndQuestions(defaultCategories, new Set());
    setFilingExcemptionCategories(defaultCategories);
    setResultsEnabled(true);
  }

  const handleNextButton = () => {
    let defaultCategories = [...filingCategories];

    let selectedCategoryIdsSet = new Set();
    filingExcemptionTiles.forEach((cat) => {
      if (cat.selected === true) {
        selectedCategoryIdsSet.add(cat.categoryId);
      }
    });

    resetAllCategoryAndQuestions(defaultCategories, selectedCategoryIdsSet);
    setFilingExcemptionCategories(defaultCategories);
    setResultsEnabled(false);
    autoScrollCategoryTiles(`filing-category-questions-container`);
  };

  const filingTilesContainer = (
    <div className="filing-tiles-container">
      <div className="filing-tiles-container-header-title">
        {filingExcemptionTileHeaderText}
      </div>
      <div className="filing-tiles-container-grid">
        <div className="filing-category-row">{getTileRow([1, 2, 3])}</div>
        <div className="filing-category-row">{getTileRow([4, 5, 6])}</div>
        <div className="filing-category-row">{getTileRow([7, 8, 9])}</div>
        <div className="filing-category-row">{getTileRow([10, 11, 12])}</div>
        <div className="filing-category-row">{getTileRow([13, 14, 15])}</div>
        <div className="filing-category-row">{getTileRow([16, 17, 18])}</div>
        <div className="filing-category-row">{getTileRow([19, 20, 21])}</div>
        <div className="filing-category-row">{getTileRow([22, 23])}</div>
      </div>

      <div className="filing-tiles-next-container">
        <button className="none-button" onClick={() => handleNoneApplyButton()}>
          <span>None Apply</span>
        </button>
        <button className="next-button" onClick={() => handleNextButton()}>
          <span>Check Exemptions</span>
        </button>
      </div>
    </div>
  );

  const handleFilingQuestionClick = (selectedOption, category, question) => {
    let oldCategories = [...filingExcemptionCategories];
    oldCategories
      .find((c) => c.categoryId === category.categoryId)
      .questions.find((q) => q.id === question.id).selection = selectedOption;
    setFilingExcemptionCategories(oldCategories);

    const updatedCategory = oldCategories.find(
      (c) => c.categoryId === category.categoryId
    );
    const isAllQuestionedAnsweredOfthisCategory =
      updatedCategory.questions.every((q) => q.selection !== null);

    if (isLastSelection([...oldCategories], category.categoryId)) {
      if (isAllQuestionedAnsweredOfthisCategory) {
        setResultsEnabled(true);
        return;
      }
    }

    if (isAllQuestionedAnsweredOfthisCategory) {
      const isModalRequired =
        updatedCategory.questions.filter((c) => c.selection === "Yes").length >=
        updatedCategory.requiredCount;

      if (!isModalRequired) {
        scrollToNextCategory(oldCategories, category);
      } else {
        autoScrollCategoryTiles(`dynamic-dialog-${category.categoryId}`);
      }
    }
  };

  const scrollToNextCategory = (oldCategories, category) => {
    for (
      let categoryCount = category.categoryId + 1;
      categoryCount < oldCategories.length;
      categoryCount++
    ) {
      if (
        oldCategories.find((c) => c.categoryId === categoryCount)?.selected ===
        true
      ) {
        autoScrollToNextCategory(categoryCount);
        break;
      }
    }
  };

  const filingQuestions = (
    <div className="filing-category-questions-container">
      {filingExcemptionEnabled &&
        getVetifiedSelectedCategories(filingExcemptionCategories).map(
          (cat, _categoryIndex, _allCategories) => {
            return (
              <div
                key={`filing-questions-category-${cat.categoryId}`}
                className={`filing-questions-category filing-questions-category-${cat.categoryId}`}
              >
                <div className="filing-questions-category-header">
                  {cat.categoryTitle}
                </div>
                <div className="filing-questions-category-content">
                  {cat.questions.map(
                    (question, _questionIndex, _allQuestionsOfCurrentCat) => {
                      return (
                        <div
                          key={`filing-category-${cat.categoryTitle}-${question.id}`}
                          className="filing-questions-template"
                        >
                          <div className="filing-questions-template-title-container">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: question.title,
                              }}
                            />
                          </div>

                          {question.points && question.points.length > 0 && (
                            <div className="filing-questions-template-points-container">
                              <ul>
                                {question.points?.map((p) => {
                                  return (
                                    <li key={`${p}`}>
                                      <div
                                        dangerouslySetInnerHTML={{ __html: p }}
                                      />
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          )}

                          <div className="question-radio-container">
                            <label className="radio-label-container">
                              <input
                                type="radio"
                                name={`${question.title}-${question.id}`}
                                value="Yes"
                                onChange={() =>
                                  handleFilingQuestionClick(
                                    "Yes",
                                    cat,
                                    question
                                  )
                                }
                                checked={question.selection === "Yes"}
                              />
                              <span className="radio-label-container-option">
                                Yes
                              </span>
                            </label>
                            <label className="radio-label-container">
                              <input
                                type="radio"
                                name={`${question.title}-${question.id}`}
                                value="No"
                                onChange={() =>
                                  handleFilingQuestionClick("No", cat, question)
                                }
                                checked={question.selection === "No"}
                              />
                              <span className="radio-label-container-option">
                                No
                              </span>
                            </label>
                          </div>
                        </div>
                      );
                    }
                  )}
                </div>
                <div className="filing-questions-dynamic-dialog">
                  {!!showDynamicModal([...filingExcemptionCategories], cat) &&
                    dynamicDialog(cat)}
                </div>
              </div>
            );
          }
        )}
    </div>
  );

  //#endregion

  //#region Results
  //#endregion

  return (
    <div className="page-container">
      <div className="company-overview">
        {companyOverviewHeader}
        {companyOverviewContent}
        {staticDialog}
        {showDynamicDialogForCompany && dynamicDialog(CompanyOverviewCategory)}
      </div>
      {filingExcemptionEnabled && (
        <div className="filing-exemptions">
          {filingExcemptionHeader}
          {filingTilesContainer}
          {filingQuestions}
        </div>
      )}

      {resultsEnabled && (
        <div className="result">
          <Result
            showDynamicText={
              companyQuestion?.length > 0 &&
              companyQuestion[0].selection === "Yes"
            }
            allCategories={[...filingExcemptionCategories]}
            showCompanyOverviewTemplate={(companyQuestion || []).every(
              (q) => q.selection === "Yes"
            )}
          />
        </div>
      )}
    </div>
  );
}

export default Pagecontent;
